module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/double-cab-pick-up-active.3ed70795.svg";